/** Strip non-digits from an SSN-like string. */
export const digitsOnly = (value: string = ""): string => {
  return value ? value.replace(/\D/g, "") : value;
};

/** Format digits as ###-##-####, capped at 9 digits. */
export const formatSSN = (value: string = ""): string => {
  if (!value) return "";
  const ssn = digitsOnly(value).slice(0, 9);

  if (ssn.length === 0) return "";
  if (ssn.length <= 3) return ssn;
  if (ssn.length <= 5) return `${ssn.slice(0, 3)}-${ssn.slice(3)}`;
  return `${ssn.slice(0, 3)}-${ssn.slice(3, 5)}-${ssn.slice(5)}`;
};

/**
 * SSA-aligned SSN checks used by Backoffice `SocialSecurityNumber` scalar.
 * Accepts 9 digits (with or without hyphens). Empty is treated as valid (optional field).
 */
export const isValidSsn = (value: string = ""): boolean => {
  if (!value) return true;

  const ssn = digitsOnly(value);
  if (!/^\d{9}$/.test(ssn)) return false;

  const area = ssn.slice(0, 3);
  const group = ssn.slice(3, 5);
  const serial = ssn.slice(5, 9);

  if (area === "000" || group === "00" || serial === "0000") return false;
  if (area === "666") return false;

  return true;
};

export const ssnValidationMessage = "Value is not a properly formatted social security number";
